<template>
 <section>
    <Header :user="user" />
    <main class="main animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
      <div class="contenedor py-0">
        <h4>{{ getTittle() }}</h4>
         <div class="row px-0 py-0">
            <div class="col-12 px-2 py-0">
              <OliverSalesDashboardTabs />
            </div>
        </div>
        </div>
    </main>
 </section>
</template>

<script>

import OliverSalesDashboardTabs from "@/components/Performances/OliverSalesDashboardTabs.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: 'OliverSalesDashboard',
  components: {
    OliverSalesDashboardTabs
  },
  mounted() {
    this.setHeader();
  },
  data() {
    return {

    };
  },
    computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
    methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    setHeader(){
      switch (parseInt(this.$route.params.item)) {
        case 1:
          this.setCurrentRoute({ page: "monthly-metrics", label: "Monthly metrics" });
          break;
        case 2:
          this.setCurrentRoute({ page: "global-metrics", label: "Global metrics" });
          break;
        case 3:
          this.setCurrentRoute({ page: "ranking", label: "Ranking" });
          break;
        case 4:
          this.setCurrentRoute({ page: "actions", label: "Actions" });
          break;
        case 5:
          this.setCurrentRoute({ page: "team", label: "Team" });
          break;
        case 6:
          this.setCurrentRoute({ page: "achievements", label: "Achievements" });
          break;
      }
    },
    getTittle(){
      switch (parseInt(this.$route.params.item)) {
        case 1:
          return "Monthly metrics";
        case 2:
          return "Global metrics";
        case 3:
          return "Ranking";
        case 4:
          return "Actions";
        case 5:
          return "Team";
        case 6:
          return "Achievements";
      }
    },

    }
};
</script>
